import { Button, Text, Tooltip, TrashIcon, UndoIcon } from '@mercai/clever'

import { ChainLinkProps } from './chain-link.type'

import styles from './chain-link.module.css'

export const ChainLink = ({
  value,
  itemIndex,
  linkIndex,
  onRemoveChainLink,
  onRevertChainLink,
  isMarkedAsRemoved = false,
}: ChainLinkProps) => {
  const buyerName =
    value?.saleOrder?.buyer?.companyName || value?.saleOrder?.buyer?.name || '-'
  const saleOrderReference = value?.saleOrder?.reference || '-'
  const quantity = value?.quantity || 0

  return (
    <div
      className={`${styles.container} ${isMarkedAsRemoved ? styles.removed : ''}`}
    >
      <div className={styles['first-column']}>
        <div className={styles['buyer-and-reference']}>
          <Tooltip text={buyerName} className={styles.tooltip}>
            <Text variant="text-base" className={styles.buyer}>
              {buyerName}
            </Text>
          </Tooltip>
          <Text variant="text-small" className={styles.reference}>
            {saleOrderReference}
          </Text>
        </div>
        <div>
          {isMarkedAsRemoved ? (
            <Button
              variant="ghost"
              model="round"
              onClick={() => onRevertChainLink?.(itemIndex, linkIndex)}
              className={styles['revert-button']}
            >
              <UndoIcon />
            </Button>
          ) : (
            <Button
              variant="ghost"
              model="round"
              onClick={() => onRemoveChainLink(itemIndex, linkIndex)}
              className={styles['remove-button']}
            >
              <TrashIcon />
            </Button>
          )}
        </div>
      </div>
      <div className={styles.column}></div>
      <div className={styles.column}>
        <Text variant="text-small">{quantity} kg</Text>
      </div>
      <div className={styles.column}></div>
      <div className={styles.column}></div>
    </div>
  )
}
